// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Kli8T","content":"styles_content__3En9L","selectAll":"styles_selectAll__2b1aA"};